module.exports = __webpack_public_path__ + "static/img/originImg1.4d5db75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/originImg1.png
// module id = eITt
// module chunks = 0